import { listPersonalBests, PB_LABEL, type PbRow } from '@gymtv/data';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { supabase } from '../lib/supabase';

export function Bests() {
  const { units } = useAuth();
  const [rows, setRows] = useState<PbRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    listPersonalBests(supabase).then(setRows, (e) => setError(e.message));
  }, []);
  const groups = new Map<string, PbRow[]>();
  for (const r of rows ?? []) groups.set(r.exercise_id, [...(groups.get(r.exercise_id) ?? []), r]);
  const val = (p: PbRow | undefined) => (p ? `${p.value}${p.kind === 'max_reps' ? ' reps' : ` ${units}`}` : '—');
  return (
    <>
      <div className="page-head">
        <h1>Personal bests</h1>
      </div>
      {error && <p className="error">{error}</p>}
      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>Exercise</th>
              <th>{PB_LABEL.max_weight}</th>
              <th>{PB_LABEL.e1rm}</th>
              <th>{PB_LABEL.max_reps}</th>
              <th>Latest</th>
            </tr>
          </thead>
          <tbody>
            {rows?.length === 0 && (
              <tr>
                <td colSpan={5} className="muted">Finish a workout to start tracking personal bests.</td>
              </tr>
            )}
            {[...groups.values()].map((list) => {
              const by = (k: PbRow['kind']) => list.find((p) => p.kind === k);
              const latest = list.reduce((a, b) => (a.achieved_at > b.achieved_at ? a : b));
              return (
                <tr key={list[0]!.exercise_id}>
                  <td>
                    <Link to={`/exercises/${list[0]!.exercise_id}`}>
                      <b>{list[0]!.exercise_name}</b>
                    </Link>
                  </td>
                  <td className="num">{val(by('max_weight'))}</td>
                  <td className="num">{val(by('e1rm'))}</td>
                  <td className="num">{val(by('max_reps'))}</td>
                  <td className="num muted">{new Date(latest.achieved_at).toLocaleDateString()}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
